import {
    apiRequest,
    pensiunSubmission
} from "../../../../../services/adapters/kepegawaian/pensiunService"

class SubmissionRepository {

    fetchSubmit = async (query) => {
        return await apiRequest("post", pensiunSubmission, {
            body: query
        }, true)
    }
    
}

export default SubmissionRepository